import React from 'react';

// Styles
import {
	ContentWrapperStyled,
	CenterContainerStyled,
} from './ErrorContainer.styled';

const ErrorContainer = () => {
	return (
		<ContentWrapperStyled>
			<CenterContainerStyled>Sorry something went wrong.</CenterContainerStyled>
		</ContentWrapperStyled>
	);
};

export default ErrorContainer;
